"use strict";

var global = require("global");

module.exports = {
	openSettings: noop,
	bringApptoBackground: noop,
	bringApptoForeground: bringApptoForeground,
	lightScreen: noop,
	clearWindow: noop,
};

function bringApptoForeground(){
	var window = null;
	try{
		window = global.require("electron").remote.getCurrentWindow();
	} catch(err) {
		window = global.require("nw.gui").Window.get();
	}
	if(!window) return;
	window.setAlwaysOnTop(true);
	window.focus();
	window.setAlwaysOnTop(false);
}

function noop() {}
